import { css } from '@emotion/react';

import { type LinkUnderline } from './Link.types';

export const linkBaseStyles = css`
  display: inline;
  cursor: pointer;
  text-decoration: none;
  margin: 0;
  color: inherit;

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

export const linkUnderlineStyles: Record<
  LinkUnderline,
  ReturnType<typeof css>
> = {
  always: css`
    text-decoration: underline;
    text-underline-offset: 2px;
  `,
  hover: css`
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  `,
  none: css`
    text-decoration: none;
  `,
};
